import { useLogs } from '../call-log/hooks'

export type Recording = {
  recordingUrl: string
  recordingId: string
  recordingDuration: number
  callSid: string
  callTime: string
  callType: string
}

export const useCallRecordings = (id: string | number | undefined) => {
 
  const { data: callLogs } = useLogs()
  if (!id) return []

  const recordings: Recording[] = callLogs
    ?.filter(c => id.toString().replace(/\D/g, '').replace(/^1/, '') === c.phoneNo.replace(/\D/g, '').replace(/^1/, ''))
    .filter( c => !!c.recordingId )
    .map((callLog: any) => {
      return {
        recordingUrl: callLog.recordingUrl,
        recordingId: callLog.recordingId,
        recordingDuration: 0,
        callSid: callLog.callSid,
        callTime: callLog.callTime,
        callType: callLog.callType,
      }
    })

  return recordings
}
